import { render, staticRenderFns } from "./entregas-dhl.vue?vue&type=template&id=161d4eb0&scoped=true&"
import script from "./entregas-dhl.vue?vue&type=script&lang=js&"
export * from "./entregas-dhl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d4eb0",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WTopBar})
